import HTTPError from 'http-errors'
export default HTTPError



// WEBPACK FOOTER //
// ../webmango-utils/errors.js